import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BasePage } from 'src/app/lib/base-page';
import { UserRepository } from 'src/app/repositories/user.repository';
import { LoaderService } from 'src/app/services/loader.service';
import { LoginService } from 'src/app/services/login.service';
import { MobilityService } from 'src/app/services/mobility.service';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-mobility-enter-coupon-code',
  templateUrl: './mobility-enter-coupon-code.page.html',
  styleUrls: ['./mobility-enter-coupon-code.page.scss'],
})
export class MobilityEnterCouponCodePage extends BasePage implements OnInit {



  couponCode: string = '';

  constructor(
    private modalService: ModalService,
    private mobilityService: MobilityService,
    private router: Router,
    private loaderService: LoaderService,
    private loginService: LoginService,
  ) {
    super();
  }

  ngOnInit() {}

  validateCode(text: string): string|null {
    var code_format = /[A-Z0-9]/;
    if(text !== undefined && text !== ''){
      if (!code_format.test(text)) {
        return 'Das Format des Gutscheincodes ist nicht korrekt.';
      }
      if(code_format.test(text)){
        return 'valid';
      }
    }
    return null;

  }

  async showModal() {
    await this.loaderService.loader();
    this.mobilityService.sendCouponCode(this.couponCode.replace(/([\s]+)/g, '')).subscribe(async res => {
      if (res.message.status === 'success') {
        await this.loaderService.dismiss();
        this.modalService.showModal(
          'Freischaltung erfolgreich',
          ['Vielen Dank! Sie können den Bereich Mobilität in der App und Webapp nun vollumfänglich nutzen.'],
          [{
            text: 'Verstanden und weiter',
            color: 'primary',
          classes: 'button-primary-interaction',
          onClick: () => this.goToMobility()
        }])
      } else {
        await this.loaderService.dismiss();
        this.modalService.showModal(
          'Fehler',
          ['Der Gutscheincode ist ungültig.'],
          [{
            text: 'Verstanden',
            color: 'primary',
          classes: 'button-primary-interaction',
          onClick: () => this.modalService.dismiss()
        }])
      }
    })
  }

  private goToMobility() {
    this.loginService.profile().subscribe(res => {
      UserRepository.getInstance().user(res.data);
      this.modalService.dismiss()
      if (this.mobile) this.router.navigateByUrl('/tabs/mobility/intro')
      else this.router.navigateByUrl('/mobility/intro')
    })
  }

}
